import { action as apiAction } from 'api/Api'
import {
  setMyBoard
} from '../redux/myBoard'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  vListId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, vListId } = payload

  const state = getState()

  const currentMyBoard = state['view-card'].myBoard[cardId].myBoard
  const vList = state['view-myboard'].lists[vListId]

  let optimisticAction
  if (currentMyBoard && vList) {
    optimisticAction = optimisticDispatch(dispatch, setMyBoard({
      cardId,
      myBoard: {
        ...currentMyBoard,
        vListId,
        vListName: vList.name
      }
    }))
  }

  try {
    await apiAction('ChangeVCardParent', {
      containerFromId: currentMyBoard.vListId,
      containerToId: vListId,
      id: currentMyBoard.vCardId,
      position: 0
    })

    optimisticAction?.commit()
  } catch (error) {
    optimisticAction?.revert()

    throw error
  }
}
